<script setup lang="ts">
import CalendarCheckIcon from '@fortawesome/fontawesome-free/svgs/regular/calendar-check.svg?component';
</script>

<template>
  <RouterLink
    class="btn btn-dark btn-intro btn-sm d-none d-md-inline"
    to="/timetable"
  >
    {{ $t`Book online` }}
  </RouterLink>

  <RouterLink
    class="btn btn-lg btn-link link-body d-md-none"
    to="/timetable"
    :title="$t`Book online`"
  >
    <CalendarCheckIcon class="inline-fill" />
  </RouterLink>
</template>
